import React from "react";
import {
  InlineStack,
  Text,
  Badge,
  Checkbox,
  ProgressBar,
  Box,
  BlockStack,
} from "@shopify/polaris";

/**
 * Video Row Component
 * Individual video with selection checkbox and status
 */
const VideoRow = ({ video, isSelected, onToggle }) => {
const videoName = video.name || "Untitled";
const lectureName = video.lecture_name || "Untitled";

  const getStatusBadge = () => {
    switch (video.status) {
      case "complete":
        return <Badge tone="success">✅ HLS</Badge>;
      case "mp4":
        return <Badge tone="info">⚠️ MP4</Badge>;
      case "processing":
        return <Badge tone="warning">⟳ Processing {video.progress}%</Badge>;
      case "pending":
        return <Badge tone="attention">⏳ Pending</Badge>;
      case "failed":
        return <Badge tone="critical">❌ Failed</Badge>;
      default:
        return <Badge>Unknown</Badge>;
    }
  };

  const canSelect = video.status === "mp4";

  return (
    <Box
      padding="3"
      background="bg-surface"
      borderRadius="200"
      borderColor="border"
      borderWidth="025"
    >
      <InlineStack align="space-between" blockAlign="center" wrap={false}>
        {/* Checkbox + Video Info */}
        <InlineStack gap="4" blockAlign="center" wrap={false}>
          {canSelect ? (
            <Checkbox
              checked={isSelected}
              onChange={onToggle}
              label=""
            />
          ) : (
            <div style={{ width: "20px" }} /> // Spacer for alignment
          )}

          <div style={{ flex: 1, minWidth: 0 }}>
            <BlockStack gap="1">
              <Text as="p" variant="bodyMd" fontWeight="semibold" truncate>
                {videoName}
              </Text>
              <Text as="p" variant="bodySm" tone="subdued" truncate>
                {lectureName}
              </Text>
            </BlockStack>
          </div>
        </InlineStack>

        {/* Status */}
        <div style={{ minWidth: "120px", textAlign: "right" }}>
          {getStatusBadge()}
        </div>
      </InlineStack>

      {/* Progress Bar for converting videos */}
      {video.status === "processing" && (
        <Box paddingBlockStart="2">
          <ProgressBar progress={video.progress} size="small" />
        </Box>
      )}

      {/* Error message for failed videos */}
      {video.status === "failed" && video.error && (
        <Box paddingBlockStart="2">
          <Text as="p" variant="bodySm" tone="critical">
            {video.error}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default VideoRow;